module.exports = __webpack_public_path__ + "images/8da2bae4ebbe1bc164cd6d08c274d319.png";